import { useState, useEffect } from "react"
import Swal from "sweetalert2"
import { getProperty, updateProperty } from "../../actions/property-actions"
import { useApp } from "../../context/useApp"
import Paginator from "../../components/paginator/paginator"
import { Link, useParams } from "react-router-dom"
import { formatDate } from "../../actions/global-actions"
import TableComponent from "../../components/table/table"

function ExpensesList() {
  const params = useParams()
  const [expenses, setExpenses] = useState([])
  const [loadData, setLoadData] = useState(true)
  const { user, setLoading } = useApp()
  const currentLink = "/inmuebles"
  const [currentData, setCurrentData] = useState({})

  useEffect(() => {
    const getFunction = (response) => {
      let data = response.data
      if (data.code === "01") {
        Swal.fire({
          title: "Error",
          confirmButtonColor: "#76b4ff",
          text: data.message,
        })
      } else {
        //console.log(data[0]);
        let expenses = data[0].expenses

        let expensesArray = []
        for (let index = 0; index < expenses.length; index++) {
          let expense = expenses[index]
          expense.person = `${expense.creationUserID.firstName} ${expense.creationUserID.lastName}`
          expense.formatteDate = formatDate(expense.createdAt, 2)
          expense.date = new Date(expense.createdAt)
          expensesArray.push(expense)
        }
        expensesArray.sort((a, b) => b.date - a.date)

        setExpenses(expensesArray)
        setCurrentData(data[0])
      }
    }
    if (loadData) {
      setLoadData(false)
      setExpenses([])
      setCurrentData({})
      ;(async () => {
        try {
          const result = await getProperty(params.id, setLoading, user.token)
          getFunction(result)
        } catch (error) {
          console.error("Error fetching property:", error)
        } finally {
          setLoading(false)
        }
      })()
    }
  }, [loadData, user.token, params.id, setLoading])

  const handleOnClick = (expense) => {
    if (
      window.confirm(
        `¿Realmente desea eliminar el gasto: '${expense.description}'`,
      )
    ) {
      const expenseIndex = expenses.findIndex((e) => e._id === expense._id)
      if (expenseIndex !== -1) {
        expenses.splice(expenseIndex, 1)
        let data = JSON.parse(JSON.stringify(currentData))
        data.expenses = expenses
        //console.log(data);
        ;(async () => {
          try {
            const result = await updateProperty(data, setLoading, user.token)
            updateFunction(result)
          } catch (error) {
            console.error("Error updating property:", error)
          } finally {
            setLoading(false)
          }
        })()
      }
    }
  }

  const updateFunction = (data) => {
    if (data.code === "01") {
      Swal.fire({
        title: "Error",
        confirmButtonColor: "#76b4ff",
        text: data.message,
      })
    } else {
      setLoadData(true)

      Swal.fire({
        title: "¡Éxito!",
        confirmButtonColor: "#76b4ff",
        text: "Gasto eliminado con éxito",
      })
    }
  }

  useEffect(() => {
    //console.log(currentData)
  }, [currentData])

  return (
    <div className="w-100 d-flex">
      <div className="container d-flex flex-column">
        <div className="w-100 mt-5">
          <Link
            to={`${currentLink}/${params.id}/editar`}
            className="back-button"
          >
            &#60; Volver - Editar inmueble
          </Link>
        </div>
        <h1 className="my-5">Gastos - Inmueble {currentData.code}</h1>
        <div className="d-flex justify-content-end">
          <Link
            to={`${currentLink}/${params.id}/nuevo-gasto`}
            className="primary-button"
          >
            Registrar gasto
          </Link>
        </div>
        <TableComponent
          id="expenses-table"
          headers={["Fecha", "Valor", "Descripción", "Usuario"]}
          body={[
            { data: "formatteDate", classname: "" },
            { data: "valueSurf", classname: "" },
            { data: "description", classname: "" },
            { data: "person", classname: "" },
          ]}
          data={expenses.map((expense) => ({
            ...expense,
            valueSurf: `$${expense.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
            editLink: `${currentLink}/${params.id}/gastos/${expense._id}/editar`,
          }))}
          skip={0}
          deleteAction={handleOnClick}
          needOptions={true}
        />
      </div>
    </div>
  )
}

export default ExpensesList
